import { HumanMaleFemaleChildIcon } from './HumanMaleFemaleChildIcon';

/**
 * author: Google
 * id 26B43897-F5DF-4CBC-A89F-514E200B5937
 * name human-male-female-child
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-female-child.svg
 * tags
 * - People / Family 
 */
export const MomDadChildIcon = HumanMaleFemaleChildIcon;
export default MomDadChildIcon